
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import { tokenIsExpired } from "../../authUtils";
import { Assessment, Receipt, Inventory, Settings } from "@mui/icons-material";
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import { Card, CardContent, Button, Grid, Typography, Avatar, Box, IconButton } from "@mui/material";
import { fetchData, updateData, postData, deleteData } from '../../apiService';

function Home() {
    const { isAuthenticated, companyId, username, userId, logout, token, permissions, roleName } = useAuth();
    const [showReports, setShowReports] = useState(false);
    const [favorites, setFavorites] = useState([]);
    const { id } = useParams();
    // const companyId = 1; 
    // const username = "Faman";
    // const isAuthenticated = true;

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
       // fetchtableData();
    }, [isAuthenticated]);

    return (
        <div className="container mx-auto p-4">
            <div>
                <Typography variant="h6" className="font-bold justify-end flex items-end" style={{ fontSize: '14px', fontFamily: 'monospace', color: '#1A1A1D', textTransform: 'uppercase' }}>
                    <Diversity1Icon style={{ color: '#547792', fontSize: '14px' }} />
                    <span style={{ fontFamily: 'monospace', fontSize: '12px', marginLeft: '10px', color: '#1A1A1D', textTransform: 'uppercase' }}>
                        Welcome Back, {username || "Guest"}!
                    </span>
                </Typography>
            </div>
        </div>
    );
}

export default Home;